/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    addButton: "Ajouter",
    checkboxFalseStringValue: "Non",
    checkboxTrueStringValue: "Oui",
    confirmDelete: "Etes-vous sur de vouloir supprimer ?",
    deleteButton: "Supprimer",
    editButton: "Editer",
    footerInfo: {
        displayableRowsCount: {
            noFilter: {
                plural: ghb({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(((helper = (helper = lookupProperty(helpers,"nbrTotalRows") || (depth0 != null ? lookupProperty(depth0,"nbrTotalRows") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"nbrTotalRows","hash":{},"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":16}}}) : helper)))
    + " lignes";
},"useData":true}),
                singular: ghb({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(((helper = (helper = lookupProperty(helpers,"nbrTotalRows") || (depth0 != null ? lookupProperty(depth0,"nbrTotalRows") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"nbrTotalRows","hash":{},"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":16}}}) : helper)))
    + " ligne";
},"useData":true})
            },
            withFilter: {
                plural: ghb({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(((helper = (helper = lookupProperty(helpers,"nbrDisplayableRows") || (depth0 != null ? lookupProperty(depth0,"nbrDisplayableRows") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"nbrDisplayableRows","hash":{},"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":22}}}) : helper)))
    + " sur "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"nbrTotalRows") || (depth0 != null ? lookupProperty(depth0,"nbrTotalRows") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"nbrTotalRows","hash":{},"data":data,"loc":{"start":{"line":1,"column":27},"end":{"line":1,"column":43}}}) : helper)))
    + " lignes";
},"useData":true}),
                singular: ghb({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(((helper = (helper = lookupProperty(helpers,"nbrDisplayableRows") || (depth0 != null ? lookupProperty(depth0,"nbrDisplayableRows") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"nbrDisplayableRows","hash":{},"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":22}}}) : helper)))
    + " sur "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"nbrTotalRows") || (depth0 != null ? lookupProperty(depth0,"nbrTotalRows") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"nbrTotalRows","hash":{},"data":data,"loc":{"start":{"line":1,"column":27},"end":{"line":1,"column":43}}}) : helper)))
    + " ligne";
},"useData":true})
            }
        },
        selectedRowsCount: {
            plural: ghb({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(((helper = (helper = lookupProperty(helpers,"nbrSelectedRows") || (depth0 != null ? lookupProperty(depth0,"nbrSelectedRows") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"nbrSelectedRows","hash":{},"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":19}}}) : helper)))
    + " lignes sélectionnées";
},"useData":true}),
            singular: ghb({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(((helper = (helper = lookupProperty(helpers,"nbrSelectedRows") || (depth0 != null ? lookupProperty(depth0,"nbrSelectedRows") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"nbrSelectedRows","hash":{},"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":19}}}) : helper)))
    + " ligne sélectionnée";
},"useData":true})
        }
    },
    hierarchy: {
        collapse: {
            all: "Replier toutes les lignes"
        },
        expand: {
            all: "Déplier toutes les lignes"
        }
    },
    impossibleToMultiSelect: "Impossible d'éffectuer une édition multiple",
    multipleLineSelected: "Plusieurs lignes sélectionées",
    multiselect: {
        selectAll: "Tout sélectionner",
        unselectAll: "Tout désélectionner"
    },
    noDataToDisplay: "<< Aucune donnée >>",
    noLineSelected: "Aucune ligne(s) sélectionnée(s)",
    paginator: {
        label: {
            entries: "entrées",
            of: "de",
            pages: "Pages",
            to: "à"
        },
        select: {
            all: "Tous"
        }
    },
    searchInputLabel: "Filtrer",
    searchInputLabelJSRegex: "(regex)",
    searchLabel: "Rechercher",
    selectLineToDelete: "Sélectionner au moins une ligne à supprimer",
    selectLineToEdit: "Sélectionner au moins une ligne à éditer"
};